document.addEventListener('DOMContentLoaded', () => {
  const drawerOpeners = document.querySelectorAll('drawer-opener');
  
  drawerOpeners.forEach(opener => {
    opener.addEventListener('click', () => {
      const drawerId = opener.getAttribute('data-drawer');
      if (!drawerId) return;

      // Aggiungo un ritardo per assicurarmi che il drawer sia aperto
      setTimeout(() => {
        const drawer = document.querySelector(drawerId);
        if (!drawer) return;

        const searchInput = drawer.querySelector('.js-drawer-search-input');
        if (searchInput) {
          searchInput.focus();
          
          if (searchInput.value) {
            searchInput.select();
          }
        }
      }, 50);
    });
  });
});